import { expVal, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

// The software theming project will have a hard dependency on Nav4. As such we don't want to fire exposures or change any UX when Nav4 is not present
// TODO: This voilates the Ratchet rule: "Do not export or wrap feature flags/gates and experiments usages..."
// Given getIsSoftwareThemingEnabled has been used and mocked in ~100 places, please update all the occurrences of getIsSoftwareThemingEnabled to use expVal directly.
export const getIsSoftwareThemingEnabled = () =>
	expVal('jira_theming_milestone_1', 'isEnabled', false) ||
	expVal('jira_theming_milestone_1', 'isEnabled', false);

// being part of M1 experiment is a prerequisite to be in M2
export const getIsSoftwareThemingM2Enabled = () =>
	getIsSoftwareThemingEnabled() && expVal('jira_theming_milestone_2', 'isEnabled', false);

export const getIsSoftwareThemingM2EnabledNoExposure = () => {
	if (!getIsSoftwareThemingEnabled()) {
		return false;
	}

	const [expConfig] = UNSAFE_noExposureExp('jira_theming_milestone_2');
	return expConfig.get('isEnabled', false);
};
